module.exports = __webpack_public_path__ + "img/advntm.a29dcd3b.svg";